export default {
  averageRunTime: null,
  longestRunTime: null,
  shortestRunTime: null,
  heartbeat: null,
  stats: [],
  lastUpdated: null,
  connection: null,
  connectionsMonitorData: [],
  connectionsMonitorDataLoading: false,
  connectionsOverallStatus: null,
  connectionsRunStatusLoading: false,
  heartbeatMonitorStatus: [],
  heartbeatMonitorStatusLoading: false,
};
